export default function consolidatedReportsListTableColumns(config) {
    let result = {};
    let tableData = [];
    if (!config.data) return null;

    config.data.map((consolidatedReports) => {
        let row = [];
        const rowId = consolidatedReports.reportId || consolidatedReports.businessId;
        config.columns.forEach(column => {

            let columnValue = "";
            let displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;

            if (columnDataType === "string") {
                if (column.id === "dateOfGeneration") {
                    let value = '';
                    if (consolidatedReports.reportGeneratedDate) {
                        const valueList = consolidatedReports.reportGeneratedDate.split(' ');
                        value = valueList[0] ? valueList[0].split("/").reverse().join("-") : "";
                        value = value && valueList[1] ? value + ' ' + valueList[1] : '';
                    } else if (consolidatedReports.reportGenerationDate) {
                        const valueList = consolidatedReports.reportGenerationDate.split(' ');
                        value = valueList[0] ? valueList[0].split("/").reverse().join("-") : "";
                        value = value && valueList[1] ? value + ' ' + valueList[1] : '';
                    }
                    columnValue = value;
                    displayAsIs = true;
                }
                else if (column.id === "download") {
                    columnValue = consolidatedReports.userId || "";
                    displayAsIs = true;
                }
            }

            row.push({
                [column.id]: {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    clickHandler: (columnDataType === "icon" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, rowId, consolidatedReports.reportGeneratedDate) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}
